import { GraphQLAction } from '../actions/GraphQLActions'
import * as constants from '../constants'
import { getAllowedLeveragesQuery } from '../graphql/schema'

export function allowedLeverages(
  leveragesState: getAllowedLeveragesQuery = { getAllowedLeverages: [] },
  action: GraphQLAction
): getAllowedLeveragesQuery {
  switch (action.type) {
    case constants.GET_ALLOWED_LEVERAGES: {
      return { ...leveragesState }
    }
    case constants.FULFILL_GET_ALLOWED_LEVERAGES: {
      const payload: getAllowedLeveragesQuery = action.allowedLeverages
      return payload ? payload : { ...leveragesState }
    }
    default:
      return leveragesState
  }
}
